<template>
  <div class="home3-page">
    <navigation-bar
      :system-name="systemName"
      :is-user-logged-in="isUserLoggedIn"
      :user-role="userRole"
      :scrolled="scrolled"
    />

    <v-main class="home3-page__main pa-0">
      <hero-section
        :system-name="systemName"
        :is-user-logged-in="isUserLoggedIn"
        :user-role="userRole"
      />
      <features-section />
      <about-section :system-name="systemName" />
      <how-it-works-section />
      <cta-section
        :system-name="systemName"
        :is-user-logged-in="isUserLoggedIn"
        :user-role="userRole"
      />
    </v-main>

    <footer-section :system-name="systemName" />

    <v-scale-transition>
      <v-btn
        v-show="showScrollTop"
        fab
        fixed
        bottom
        right
        color="primary"
        class="home3-page__scroll-top"
        aria-label="Scroll to top"
        @click="scrollToTop"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>
  </div>
</template>

<script>
import { Keys } from '@/config.js'
import auth from '@/services/AuthService'

import NavigationBar from './components/home3/NavigationBar.vue'
import HeroSection from './components/home3/HeroSection.vue'
import FeaturesSection from './components/home3/FeaturesSection.vue'
import AboutSection from './components/home3/AboutSection.vue'
import HowItWorksSection from './components/home3/HowItWorksSection.vue'
import CtaSection from './components/home3/CtaSection.vue'
import FooterSection from './components/home3/FooterSection.vue'

export default {
  name: 'Home3',
  components: {
    NavigationBar,
    HeroSection,
    FeaturesSection,
    AboutSection,
    HowItWorksSection,
    CtaSection,
    FooterSection,
  },
  data() {
    return {
      systemName: Keys.VUE_APP_SYSTEM_NAME,
      isUserLoggedIn: false,
      userRole: null,
      scrolled: false,
      showScrollTop: false,
    }
  },
  mounted() {
    this.isUserLoggedIn = auth.isUserLoggedIn()
    this.userRole = auth.getLoggedInUserRole()

    const lang = localStorage.getItem('lang') || this.$i18n.locale
    this.$setDocumentLangDir(lang)

    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      const top = window.pageYOffset || document.documentElement.scrollTop || 0
      this.scrolled = top > 60
      this.showScrollTop = top > 400
    },
    scrollToTop() {
      this.$vuetify.goTo(0)
    },
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

.home3-page {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &__main {
    overflow-x: hidden;
  }

  &__scroll-top {
    margin-bottom: 24px;
    margin-right: 24px;
    z-index: 10;
  }

  section {
    position: relative;
  }
}
</style>
